import { enumWithDefaultSchema } from "~/lib/zod/utils/enum-with-default"
import { officialColorpickerSchema } from "~/lib/zod/utils/official-colorpicker"
import { defaultSliceSchema } from "~/components/slices/constants"

export const separatorSliceSchema = defaultSliceSchema("separator").extend({
  type: enumWithDefaultSchema(["header"], "header"),
  background_color: officialColorpickerSchema(),
})
